<template>
    <div ref="target" class="search-button-dropdown" :class="{ 'is-open-search': isOpened }">
        <button type="button" ref="selectorTrigger" class="button search-button" :aria-expanded="isOpened.toString()" @click="toggle">
            <IconSearchRoute class="icon-bus" width="20" height="16" />
            <template v-if="label">
                {{ label }}
            </template>
            <template v-else>
                {{ t('search_another_route') }}
            </template>
            <IconDropdownArrow class="icon-chevron" width="10" height="6" />
        </button>
        <RouteSelector
            v-if="isOpened"
            ref="selector"
            route-name="route-single"
            class="route-search-container"
            :date="date"
            :aria-expanded="isOpened.toString()"
            :trigger-ref="selectorTrigger"
            @close="isOpened = false"
        ></RouteSelector>
    </div>
</template>

<script setup>
import { ref, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';

import RouteSelector from '@/shared/RouteSelector';
import IconDropdownArrow from '@@/icons/dropdown-arrow.svg';
import IconSearchRoute from '@@/icons/search-route.svg';

defineProps({
    date: {
        type: String,
        default: undefined,
    },
    label: {
        type: String,
        default: null,
    },
});

const { t } = useI18n({
    messages: {
        fr: {
            search_another_route: 'Autres parcours',
        },
        en: {
            search_another_route: 'Other routes',
        },
    },
});

const selectorTrigger = ref();

const isOpened = ref(false);

const selector = ref();

async function toggle() {
    if (!isOpened.value) {
        isOpened.value = true;
        await nextTick();
        if (selector.value && selector.value.focus) {
            selector.value.focus();
        }
    } else {
        isOpened.value = false;
    }
}
</script>

<style lang="scss" scoped>
.search-button-dropdown {
    z-index: 2;
    position: relative;
}
.search-button {
    svg {
        transition: all 300ms ease;
        flex-shrink: 0;
    }
    @include breakpoint(medium) {
        gap: 16px;
    }
}
.icon-bus {
    @include breakpoint(medium) {
        width: 26px;
    }
}
.icon-chevron {
    transition: transform 300ms ease;
    .is-open-search & {
        transition: transform 300ms ease;
        transform: rotate(180deg);
    }
}
.route-search-container {
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    width: 350px;
    max-width: calc(100vw - 28px);
    padding: 16px;
    background-color: $color-white;
    margin-top: 16px;
    border-radius: 15px;
    .is-open-search & {
        box-shadow: $dropdown-shadow;
    }
    @include breakpoint(medium) {
        border-radius: 20px;
    }
}
</style>
